import React, { Suspense } from "react";
import { useSearchParams } from "react-router-dom";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Users, Inbox, Loader2 } from "lucide-react";
import ErrorBoundary from "@/components/ErrorBoundary";

const AdminContacts = React.lazy(() => import("./Contacts"));
const ContactSubmissions = React.lazy(() => import("./ContactSubmissions"));

const TabLoadingFallback = () => (
  <div className="flex items-center justify-center p-12">
    <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
  </div>
);

const AudienceHub: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = searchParams.get("tab") || "contacts";

  const handleTabChange = (value: string) => {
    setSearchParams({ tab: value });
  };

  return (
    <div className="h-full">
      <div className="px-4 pt-4 md:px-8 md:pt-6">
        <h1 className="text-2xl font-bold font-display mb-4">Audience</h1>
      </div>
      
      <Tabs value={activeTab} onValueChange={handleTabChange} className="w-full">
        <div className="px-4 md:px-8">
          <TabsList className="w-full md:w-auto grid grid-cols-2 md:inline-flex">
            <TabsTrigger value="contacts" className="flex items-center gap-2">
              <Users className="h-4 w-4" />
              <span className="hidden sm:inline">All Contacts</span>
              <span className="sm:hidden">Contacts</span>
            </TabsTrigger>
            <TabsTrigger value="inbox" className="flex items-center gap-2">
              <Inbox className="h-4 w-4" />
              <span className="hidden sm:inline">Inbox</span>
              <span className="sm:hidden">Inbox</span>
            </TabsTrigger>
          </TabsList>
        </div>

        <TabsContent value="contacts" className="mt-0 p-4 md:p-8">
          <ErrorBoundary>
            <Suspense fallback={<TabLoadingFallback />}>
              <AdminContacts embedded />
            </Suspense>
          </ErrorBoundary>
        </TabsContent>
        <TabsContent value="inbox" className="mt-0 p-4 md:p-8">
          <ErrorBoundary>
            <Suspense fallback={<TabLoadingFallback />}>
              <ContactSubmissions embedded />
            </Suspense>
          </ErrorBoundary>
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default AudienceHub;
